<template>
  <div class="bj-empty">
    <el-empty
      class="empty-page"
      :class="desc ? '' : 'no-desc'"
      :description="desc"
      :image="imgUrl">
      <template slot="description">
        <slot name="description"></slot>
        <slot></slot>
      </template>
    </el-empty>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: ''
    }
  },
  props: {
    customImg: {
      type: String,
      required: false
    },
    desc: {
      type: String,
      required: false
    }
  },
  methods: {},
  mounted() {
    if (this.customImg) {
      this.imgUrl = this.customImg
      return
    }
    const themeType = this.$theme.get()?.value || 'stellar-light'
    if (themeType === 'stellar-light') {
      this.imgUrl = require('@/assets/img/no-data.png')
    } else if (themeType === 'dark') {
      this.imgUrl = require('@/assets/img/no-data-dark.png')
    }
  }
}
</script>

<style scoped lang="less">
.bj-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  .no-desc {
    :deep(.el-empty__description) {
      margin-bottom: 0;
      margin-top: 6px;
      line-height: normal;
    }
    :deep(.el-empty__bottom) {
      margin-top: 16px;
    }
  }
}
</style>
